/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Produktgruppen im Portrait-Format anzeigen
 * 
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PDFFrame from "../../partials/PDFFrame";
import VideoFrame from "../../partials/VideoFrame";
import GroupMainImage from "./GroupMainImage";

import * as portfolioActions from '../../../store/actions/portfolioActions';
import * as fileActions from "../../../store/actions/fileActions";
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";

// ###############################################################
// GroupDetailsPortrait / Details der Gruppe anzeigen
// ---------------------------------------------------------------
// Wurde noch keine Produktgruppe ausgewählt, so werden zunächst  
// die Details der Produktgruppe angezeigt. Die Details werden
// in drei Spalten angezeigt:
// 1. Spalte - Gruppen Bild
// 2. Spalte - vertikale Liste aller PDF-Dokumente zur Produktgruppe
// 3. Spalte - vertikale Liste aller MP4-Viedeos zur Produktgruppe
// 
// Vorlage: Mockups_Produktgruppe_navi.jpg
// ###############################################################
class GroupPortrait extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, path, appModus } = this.props.app;

        const dialog = utils.getDialogByPath(path);

        const node = utils.getTreePortfolio(dialog.portfolio, false);
        if (node === null) return null;

        if (dialog.groups !== '') return null;

        const pdfList = utils.getNodeFiles(node, 'pdf');

        const videoList = utils.getNodeFiles(node, 'mp4');

        const scrollBarClass = (window['cordova']) ? 'overflow-y-hidden' : 'overflow-y-auto';

        const renderPDF_row = () => {

            if (pdfList.length === 0) return null;

            const renderPDF = (d, i) => {
                return (
                    <div key={i} className="w-full pr-1">
                        <PDFFrame key={i} node={d} type='portfolio' listView={false} />
                    </div>
                )
            }

            const style = {
                height: (videoList.length === 0) ? '100%' : '60%',
                background: this.debug ? 'blue' : '',
            }

            return (
                <div className={`w-full h-full flex overflow-y-hidden ${scrollBarClass}`} style={style}>
                    {appModus === 'Admin' && renderPDF({ name: '_NEW', path: '' })}
                    {pdfList.map((d, i) => renderPDF(d, i))}
                </div>
            )
        }

        const renderMP4_row = () => {

            if (videoList.length === 0) return null;

            const renderVideo = (d, i) => {
                return (
                    <div key={i} className={"w-full " + (d.name === '_NEW' ? 'pr-2' : '')}>
                        <VideoFrame key={i} fileName={d.name} type='portfolio' />
                    </div>
                )
            }

            const style = {
                height: (pdfList.length === 0) ? '100%' : '40%',
                background: this.debug ? 'green' : '',
            }

            return (
                <div className={`flex pt-1 overflow-y-hidden ${scrollBarClass}`} style={style}>
                    {appModus === 'Admin' && renderVideo({ name: '_NEW', path: '' })}
                    {videoList.map((d, i) => renderVideo(d, i))}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            left: '25%',
            width: '75%',
            height: inputHeight + 'px'
        };

        return (
            <div className="GroupPortrait absolute w-full flex flex-col z-20 bg-forsales-gray" style={style}>
                <div className="w-full flex flex-col p-8" style={{ height: '65%' }}>
                    <GroupMainImage node={node} />
                </div>
                <div className="w-full flex flex-col px-4" style={{ height: '35%' }}>
                    {renderPDF_row()}
                    {renderMP4_row()}
                </div>
            </div>
        )

    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupPortrait);
